import axios from 'axios';
// Internal
import config from 'config/config';
import errorResponseStatus from 'constants/errorResponseStatus';
import { logErrorToAtatus } from './atatus';

/**
 * Initialise axios with a common base URL for the service requests
 */
const commonAxios = axios.create({
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
    }
});

commonAxios.interceptors.request.use((req) => {
    // Sets the token in the request's headers
    const token = localStorage.getItem(config.TOKEN);
    req.headers.authorization = `Bearer ${token}`;

    // Sets the brand information
    if (!req.headers.common.Brand) {
        let userData = localStorage.getItem(config.USERDATA);
        userData = JSON.parse(userData);
        req.headers.common.Brand = userData && userData.brand ? userData.brand : config.BRAND;
    }

    return req;
});

commonAxios.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response) {
            /*
            * The request was made and the server responded with a
            * status code related to auth/permissions
            */
            if (
                err.response.status === errorResponseStatus.forbidden
                || err.response.status === errorResponseStatus.unauthorised
            ) {
                if (window.location.pathname !== '/login') {
                    window.location.replace('/login');
                }
                // If the error is 401 it removes the item
                if (err.response.status === errorResponseStatus.unauthorised) {
                    localStorage.removeItem(config.TOKEN);
                }
            } else {
                if(err?.response?.status === 500) {
                    logErrorToAtatus(`Internal Server Error at ${err.config.url}`, { details: {
                        url: err?.config?.url,
                        method: err?.config?.method,
                        status: err?.response?.status,
                        data: err?.response?.status,
                    }});
                }
            }
        }
        throw err;
    }
);

export default commonAxios;
